import wrappedAxios from './wrappedAxios';
import { HOTELS_API_URL } from 'config';
import queryValuesToString from 'lib/routing/queryValuesToString';

export const searchLocationAvailability = async ({
  location,
  checkIn,
  checkOut,
  adults,
  children,
  infants,
  page,
  sortBy,
  accessToken,
  propertyTypes,
  flightBookerToken,
  minStarRating,
  minTripadvisorRating,
  payWith,
  minPrice,
  maxPrice,
  featuredPropertyId,
  limit,
  swLat,
  swLng,
  neLat,
  neLng,
  facilities,
  qhUserId,
  freeCancellation,
  depositPay,
  classicRewards,
  subRegions,
}) => {
  const response = await wrappedAxios({
    url: `${HOTELS_API_URL}/locations/${location}/availability`,
    method: 'get',
    params: queryValuesToString({
      checkIn,
      checkOut,
      adults,
      children,
      infants,
      limit,
      page: page || 1,
      sortBy,
      propertyTypes,
      flightBookerToken,
      minStarRating,
      minTripadvisorRating,
      payWith,
      minPrice,
      maxPrice,
      featuredPropertyId,
      swLat,
      swLng,
      neLat,
      neLng,
      facilities,
      freeCancellation,
      depositPay,
      classicRewards,
      subRegions,
    }),
    accessToken,
    qhUserId,
  });

  return response.data;
};
